import {
    createFirebaseApp,
    createRealtimeDatabase,
    createFirestore,
    createAuth,
    createFunctions,
    createAppCheck,
    type EmulatorConfig
} from '@inloco/shared/firebase';

const config = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
};

const useEmulators = (import.meta.env.VITE_FIREBASE_USE_EMULATORS ?? 'false') === 'true';
const emulatorHostRaw = import.meta.env.VITE_FIREBASE_EMULATOR_HOST || 'localhost';

// `host.docker.internal` è pensato per essere risolto *dai container*.
// Qui però l'SDK Firestore gira nel browser: su macOS il browser spesso non risolve quel nome.
// Se stai testando localmente, `localhost` è quasi sempre la scelta corretta.
const emulatorHost = emulatorHostRaw === 'host.docker.internal' ? 'localhost' : emulatorHostRaw;

const emulatorConfig: EmulatorConfig = {
    // In produzione (container nginx) import.meta.env.DEV è false.
    // Questo flag permette di abilitare gli emulatori anche in build “prod” per test locali.
    enabled: import.meta.env.DEV || useEmulators,
    host: emulatorHost,
};

export const app = createFirebaseApp(config);
export const appCheck = createAppCheck(app, emulatorConfig);
export const rtdb = createRealtimeDatabase(app, emulatorConfig);
export const firestore = createFirestore(app, emulatorConfig);
export const func = createFunctions(app, emulatorConfig);
export const auth = createAuth(app);

export default app;